<template>
	<div v-if="visible" class="password-rules text-small text-muted" v-html="$t(text)"></div>
	<span v-else data-role="hint" :data-hint-text="$t(text)" data-cls-hint="drop-shadow">
		<span class="mif-help1 mif-1x"></span>
	</span>
</template>
<script>
export default {
	name: "PasswordInfos",
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			text: "Please enter a secure password that meets the following criteria:<br>"+
				"- Between 8 and 50 characters long<br>"+
				"- At least one uppercase letter (A-Z)<br>"+
				"- At least one lowercase letter (a-z)<br>"+
				"- At least one special character (e.g. !, @, #, %, &)"
		}
	}
}
</script>

<style scoped>
.password-rules {
	line-height: 1.5;
}
</style>
